<script>
    import { onMount } from "svelte"
    // import Circle from "./Circle.svelte"
    import CircleProgressBar from "./CircleProgressBar.svelte"
    let angle
    let days, hours, minutes, seconds, centesimi = 0;
    

    function calcTimeRemaining() {
        
        let currentTime = new Date();
        let targetTime = new Date('2024-01-01');
        let totalSeconds = Math.floor((targetTime - currentTime) / 1000);
        let totalCentesimi = Math.floor((targetTime - currentTime) / 10);
        
        // days = Math.floor(totalSeconds / (60 * 60 * 24));
        days = totalSeconds / (60 * 60 * 24);
        // hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60) -1 );
        hours = (totalSeconds % (60 * 60 * 24)) / (60 * 60) -1 ;
        // minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        minutes = (totalSeconds % (60 * 60)) / 60
        seconds = totalSeconds % 60;
        centesimi = totalCentesimi % 6000;

        return {days, hours, minutes, seconds}
    }

    onMount(() => {
        const interval = setInterval(() => {
            calcTimeRemaining()
        }, 100); // Repeat every 1000 milliseconds (1 second)
        
        // Clear the interval when the component is destroyed
        return () => clearInterval(interval);
    });

    // calcTimeRemaining()
</script>



    {#if centesimi < 0}
        <div class="good-year">
            BUON ANNO! &#127881; &#127881; &#127881;
        </div>
    {:else}
        <div class="title">Countdown per capodanno</div>
        <div class="circle-timers">
            {#key centesimi}
                <CircleProgressBar progress={days / 365 } value={Math.floor(days)} unit={"GIORNI"}/>
                <CircleProgressBar progress={hours / 24 } value={Math.floor(hours)} unit={"ORE"}/>
                <CircleProgressBar progress={minutes / 60 } value={Math.floor(minutes)} unit={"MINUTI"}/>
                <CircleProgressBar progress={centesimi / 100 / 60 } value={seconds} unit={"SECONDI"}/>
            {/key}
        </div>
    {/if}


<style>
    .title {
        font-size: 3.5em;
        font-weight: bold;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        margin: 1em;
        text-align: center;
    }
    .circle-timers {
        display: flex;
        justify-content: space-between;
        padding: 16px;
    }

    .good-year {
        margin: 0.5em;
        text-align: center;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 4em;
        font-weight: bold;
    }
</style>
